
var TECL_TenderSupplierGeneral = {

    // Close the accordian panel
    InitialiseAccordionControls: function() {

        $(".collapse").on('show.bs.collapse', function() {
            var parentNode = $(this).parent();
            parentNode.find(".panel-heading").addClass("opened");
            parentNode.find(".accordionClose").removeClass("hidden");
            parentNode.find(".accordionOpen").addClass("hidden");
        });

        $(".collapse").on('hide.bs.collapse', function() {
            var parentNode = $(this).parent();
            parentNode.find(".panel-heading").removeClass("opened");
            parentNode.find(".accordionClose").addClass("hidden");
            parentNode.find(".accordionOpen").removeClass("hidden");
        });
    }

};